import { FINANCE_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getNotifications: function ({limit = 999, page = 1, notificationType, instanceId}) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`]
    if (notificationType) query.push(`notificationType[]=${notificationType}`)
    if (instanceId) query.push(`instanceId[]=${instanceId}`)
    return instCred.get('notifications?' + query.join('&'))
  },
  editNotification: function (notification) {
    notification.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('notifications/' + notification.id, notification)
  }
}



// WEBPACK FOOTER //
// ./src/api/Notification/api.js